import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { Vue, Component, Prop } from 'vue-property-decorator';
import axios from 'axios';
import { tenantSettingsAPI } from '@/providers/apis/tenant-settings/tenant-settings';
@Component({
    name: 'tx-subject-prefer',
    components: {

    },
})

export default class TxSubjectPrefer extends Vue {

    // --------------------------------------------------------------------------
    // Properties

    @Prop()
    private selectedConfig: any;

    @Prop()
    private tenantSettings: any;

    @Prop()
    private activeValue: any;

    private classifications: any = [];

    private defaultCategory?: any = null;



    private get selectedCategory() {
        return this.classifications.filter((item: any) => item && item.isCategory) || [];
    }

    private defaultSubjects: any = {};


    private get activePreference() {
        return this.tenantSettings.find((item: any) => item.key === 'tx_sub_prefs') || {};
    }


    // -------------------------------------------------------------------------
    // Hooks

    private created() {
        if (this.activeValue) {
            this.activeValue.forEach((value: any) => {
                if (value.isActive === true) {
                    this.classifications.push(value);
                }
            });
            this.classifications.forEach((value: any, index: any) => {
                this.onSelectCategory(value, index, 0);
                this.onSelectSubject(value);
            });
        } else {
            this.onLoadCategory();
        }

    }

    // -------------------------------------------------------------------------
    // Actions

    private onSelectCategory(category: any, index: any, categoryIndex: any= null) {
        if (!category.subjects) {
            this.fetchSubject(category);
        }
        this.$set(category, 'isCategory', category.isCategory ? false : true);
        this.$set(category, 'isActive', category.isActive ? false : true);
        if (index === 0 && categoryIndex === 0) {
            this.$set(category, 'isCategory', true);
        } else if (index && categoryIndex === null) {
            this.classifications.forEach((value: any, subjectindex: any) => {
                this.$set(value, 'isCategory', false);
                if (index === subjectindex) {
                    this.$set(value, 'isCategory', true);
                } else {
                    this.$set(value, 'isCategory', false);
                }
            });
        }

    }

    private onSelectSubject(subject: any = null) {
            this.$set(subject, 'isActive', subject.isActive ? false : true);
            this.classifications.forEach((subjectList: any) => {
            subjectList.count = 0;
            if (subjectList.subjects) {
                const subjectsList = subjectList.subjects;
                subjectsList.forEach((active: any) => {
                    if (active.isActive === true) {
                        subjectList.count = 1 + subjectList.count;
                    }
                });
            }

        });
    }

    private onGoNext(categorys: any) {
        this.parseSubjectObject();
        this.$emit('onGoNext', 'tx-fw', categorys);
    }

    private onSelectDefaultSubject(category: any, subject: any) {
        if (!this.defaultSubjects[category.id] || this.defaultSubjects[category.id] !== subject.id) {
            this.$set(this.defaultSubjects, category.id, subject.id);
            return;
        }
        this.$set(this.defaultSubjects, category.id, null);
    }

    // -------------------------------------------------------------------------
    // Methods

    private onLoadCategory() {
       this.classifications = [];
       axios.all([
            tenantSettingsAPI.fetchClassifications(),
            taxonomyAPI.fetchTaxonomyClassifications(),
        ]).then(axios.spread((classificiation: any, taxonomyClassification) => {
            classificiation.map((item: any, index: any) => {
                item.count = 0;
                const txCode = taxonomyClassification.find((txItem: any) => item.id === txItem.id);
                if (txCode) {
                    if (this.selectedConfig.tenantConfig && this.selectedConfig.tenantConfig.value) {
                        this.defaultCategory = this.selectedConfig.tenantConfig.value.default_classifier;
                    }
                    this.$set(item, 'isActive', true);
                }
                if (index === 0) {
                    this.$set(item, 'isCategory', true);
                }
                this.$set(item, 'isActive', item.isActive ? false : true);
                this.$set(item, 'isCategory', item.isCategory ? false : true);
                this.onSelectCategory(item, index);
            });
            this.classifications = classificiation;
        }));
    }

    private fetchSubject(cat: any) {
        const categoryId = cat.id;
        taxonomyAPI.fetchSubjects(categoryId).then((subject) => {
            subject.forEach((item: any) => {
                if (this.activePreference && this.activePreference.value) {
                    if (this.activePreference.value[categoryId]
                        && this.activePreference.value[categoryId].gut_subject_codes.indexOf(item.id) !== -1) {
                        this.$set(item, 'isActive', true);
                        this.$set(this.defaultSubjects, categoryId, item.id);
                    }
                }
            });
            this.$set(cat, 'subjects', subject);
        });
    }

    private selectedSubjectList(categoryId: any) {
        const category = this.selectedCategory.find((item: any) => item.id === categoryId);
        if (category && category.subjects) {
            return category.subjects.filter(((item: any) => item.isActive));
        }
        return [];
    }

    private parseSubjectObject() {
        const config: any = {};
        this.selectedCategory.forEach((category: any) => {
            config[category.id] = {
                gut_subject_codes: category.subjects.filter((item: any) => item.isActive).map((item: any) => item.id),
                default_gut_subject_code: this.defaultSubjects[category.id] || null,
                is_global_visible: false,
            };
        });
        if (!this.activePreference) {
            this.$set(this.activePreference, 'value', config);
            this.$set(this.activePreference, 'key', 'tx_sub_prefs');
        }
        this.$set(this.activePreference, 'value', config);
        this.$emit('onChangeConfig', 'tx_sub_prefs', config);
    }
}
